



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class OrderAheadPickupPopup extends Vue {
  @Prop() private nextTime!: string;
}
